var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.835,
    height: 40,
    viewBox: "0 0 43.835 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud-drizzle",
    transform: "translate(0.75 0.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91198",
    "data-name": "Path 91198",
    d: "M29.69,38.953H29.6a.815.815,0,0,1,.012-1.631,10.481,10.481,0,0,0,7.144-2.744l.012-.01A10.1,10.1,0,0,0,39.6,23.842a10.075,10.075,0,0,0-8.33-7.288.815.815,0,0,1-.7-.676c-.89-5.4-3.827-9.124-8.27-10.5A13.187,13.187,0,0,0,9.149,8.806c-3.234,3.382-4,8.082-2.148,13.235a.815.815,0,1,1-1.535.551,15.917,15.917,0,0,1-.825-8.528A12.841,12.841,0,0,1,7.97,7.679,14.851,14.851,0,0,1,22.777,3.822a12.755,12.755,0,0,1,5.986,3.949,15.666,15.666,0,0,1,3.307,7.256,11.721,11.721,0,0,1,9.088,8.338,12.482,12.482,0,0,1,.235,6.561,11.25,11.25,0,0,1-3.547,5.864A12.107,12.107,0,0,1,29.69,38.953Z",
    transform: "translate(1.362 -3.958)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91199",
    "data-name": "Path 91199",
    d: "M9.569,29.273l-.059,0a8.6,8.6,0,0,1-6.132-2.959,9.143,9.143,0,0,1,0-11.536,8.6,8.6,0,0,1,6.134-2.953c.061,0,.122,0,.183,0a8.585,8.585,0,0,1,3.881.941.815.815,0,0,1-.74,1.453A6.94,6.94,0,0,0,9.6,13.451,6.845,6.845,0,0,0,2.959,20.54a6.854,6.854,0,0,0,6.667,7.1.815.815,0,0,1-.057,1.629Z",
    transform: "translate(-2.079 5.744)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91200",
    "data-name": "Path 91200",
    d: "M15.886,11.233a.815.815,0,0,1-.365-1.545A8.959,8.959,0,0,1,19.4,8.73a.815.815,0,0,1,.028,1.63,7.341,7.341,0,0,0-3.18.786A.812.812,0,0,1,15.886,11.233Z",
    transform: "translate(13.402 2.263)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91201",
    "data-name": "Path 91201",
    d: "M8.035,25.134a.815.815,0,0,1-.577-1.392l4.253-4.253a.815.815,0,0,1,1.153,1.153L8.612,24.895A.813.813,0,0,1,8.035,25.134Z",
    transform: "translate(4.558 14.115)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91202",
    "data-name": "Path 91202",
    d: "M12.035,25.134a.815.815,0,0,1-.577-1.392l4.253-4.253a.815.815,0,0,1,1.153,1.153l-4.253,4.253A.813.813,0,0,1,12.035,25.134Z",
    transform: "translate(9.064 14.115)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91203",
    "data-name": "Path 91203",
    d: "M12.035,21.134a.815.815,0,0,1-.577-1.392l4.253-4.253a.815.815,0,0,1,1.153,1.153l-4.253,4.253A.813.813,0,0,1,12.035,21.134Z",
    transform: "translate(9.064 9.608)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91204",
    "data-name": "Path 91204",
    d: "M8.035,21.134a.815.815,0,0,1-.577-1.392l4.253-4.253a.815.815,0,0,1,1.153,1.153L8.612,20.895A.813.813,0,0,1,8.035,21.134Z",
    transform: "translate(4.558 9.608)",
    fill: "#09143a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlood);
export default __webpack_public_path__ + "static/media/Flood.14e1d4c33c78c59dd813db1b5076cd17.svg";
export { ForwardRef as ReactComponent };